import { IOperatorsState } from '../states';

export const initialOperatorsState: IOperatorsState = {
  value: [],
  isFetchingOperators: false,
};
